import { FC } from "react";
import { Box, Typography } from "@mui/material";

import FileUploadButton from "../../../../common/Form/FileUpload/FileUploadButton";
import { CV, MEDICAL_REGISTRATION_CERTIFICATE } from "../../../../../constants/forms";

const QualificationRegistration: FC = (): JSX.Element => {
    return (
        <>
            <Box className="mg-b-50">
                <label className="form-label mg-b-20">3.1  Current CV - Signed </label>
                <FileUploadButton name={CV} label="Upload here" className="mg-t-0" tooltipTitle="Signed Confidentiality Agreement" />
            </Box>

            <Box className="mg-b-50">
                <label className="form-label mg-b-20">3.2  Medical Registration Certificate <Typography variant={"subtitle1"} component={"span"} color={"secondary"}> (if applicable)</Typography></label>
                <FileUploadButton name={MEDICAL_REGISTRATION_CERTIFICATE} label="Upload here" className="mg-t-0" tooltipTitle="Signed Conflict of Interest" />
            </Box>
        </>
    )
}

export default QualificationRegistration;